export class LabelEntry {
  lngClientNo: number;
  intUserNo: number;
  intIndex: number;
  labelCode: string;
  petName: string;
  specie: string;
  unitLabel: string;
  intDocNo: number;
  sglUPI: number;
  strLabelType: string; // Valid values: '' -- normal rx., 'B' -- blank rx., 'R' -- refill rx., 'W' -- written rx.
  lngTranSeq: number;
  intItemNo: number;
  strInstructions: string;
  strItemFix: string;
  sglTotal: number;

  constructor(
    lngClientNo = 0,
    intUserNo = 0,
    intIndex = 0,
    labelCode = '',
    petName = '',
    specie = '',
    unitLabel = '',
    intDocNo = 0,
    sglUPI = 0,
    strLabelType = '',
    lngTranSeq = 0,
    intItemNo = 0,
    strInstructions = '',
    strItemFix = '',
    sglTotal = 0
  ) {
    this.lngClientNo = lngClientNo;
    this.intUserNo = intUserNo;
    this.intIndex = intIndex;
    this.labelCode = labelCode;
    this.petName = petName;
    this.specie = specie;
    this.unitLabel = unitLabel;
    this.intDocNo = intDocNo;
    this.sglUPI = sglUPI;
    this.strLabelType = strLabelType;
    this.lngTranSeq = lngTranSeq;
    this.intItemNo = intItemNo;
    this.strInstructions = strInstructions;
    this.strItemFix = strItemFix;
    this.sglTotal = sglTotal;
  }
}

export class LabelTemplateModel {
  presc_text?: string;
  presc_reason_desc?: string;

  constructor(presc_text = '', presc_reason_desc = '') {
    this.presc_text = presc_text;
    this.presc_reason_desc = presc_reason_desc;
  }
}
